let language = {
    // 
    STANDARD_ORDERS_SEARCH_ORDER_NUMBER: "Order No:",
    STANDARD_ORDERS_SEARCH_ORDER_DATE: "Order Date:",
    STANDARD_ORDERS_SEARCH_ORDER_STATUS: "Status:",
    STANDARD_ORDERS_SEARCH_STORE_NAME: "Store Name:",
    STANDARD_ORDERS_SEARCH_PRODUCT_NAME: "Products:",
    
    STANDARD_ORDERS_SEARCH_FORM_RESET_BTN: "reset",
    STANDARD_ORDERS_SEARCH_FORM_SEARCH_BTN: "search",

    // 
    STANDARD_ORDERS_HEADER_OPERATION: "Operation",
    STANDARD_ORDERS_HEADER_ORDER_NUMBER: "Order No.",
    STANDARD_ORDERS_HEADER_ORDER_DATE: "Order Date",
    STANDARD_ORDERS_HEADER_PARTNER_NAME: "Name",
    STANDARD_ORDERS_HEADER_TOTAL_PRICE: "Total Price",
    STANDARD_ORDERS_HEADER_ORDER_STATUS: "Order Status",
    STANDARD_ORDERS_HEADER_ORDER_TYPE: "Combine order",
    
    // 
    STANDARD_ORDERS_CONTENT_OPTIONS: "Options",
    STANDARD_ORDERS_CONTENT_OPTIONS_CANCEL_ORDER: "Cancel Order",
    STANDARD_ORDERS_CONTENT_OPTIONS_SEE_DETAIL: "See Detail",
};

export { language }